import React from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper } from './ModalHeader.styles';
import { HeadingExtraBoldS } from '../../../../styles/globals';

const ModalHeader = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <HeadingExtraBoldS>{t('shared.modal.head')}</HeadingExtraBoldS>
    </Wrapper>
  );
};

export default ModalHeader;
